export const GST_RATE = parseInt(import.meta.env.VITE_GST_RATE || '18');